import { Coverage } from 'components/coverage-map';
const CoverageContainer = Coverage;

export { CoverageContainer };
